export default "__VITE_ASSET__ri8l8FGH__"